import { fetcher } from "helpers/fetcher";

import { TCreateOrganizationReq, TCreateOrganizationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createOrganization = async (payload?: TCreateOrganizationReq) => {
  return await fetcher<TCreateOrganizationRes, TCreateOrganizationReq["data"]>(
    ENDPOINT.CORPORATION.CREATE_ORGANIZATION,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.CREATE_ORGANIZATION.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const mutationCreateOrganization = async (
  payload?: TCreateOrganizationReq
) => {
  return (await createOrganization(payload)).data;
};

mutationCreateOrganization._key = (payload?: TCreateOrganizationReq) => [
  ENDPOINT.CORPORATION.CREATE_ORGANIZATION.url,
  payload,
];
